module.exports = __webpack_public_path__ + "static/media/hero-image-mobile@1x.271b4833.jpg";